import {apiHelper} from "../redux/apiHelper"
export const getCmsHomeSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-home-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsHomeSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-home-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsHomeSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-home-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsHomeSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-home-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsHomeSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-home-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}